import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Services from "./Services";
import "./../Styles/new.css";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";
const Home = () => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });

  const stats = [
    {
      icon: "bi bi-briefcase-fill",
      end: 50,
      suffix: "+",
      title: "Projects Completed",
    },
    {
      icon: "bi bi-people-fill",
      end: 35,
      suffix: "+",
      title: "Happy Clients",
    },
    {
      icon: "bi bi-award-fill",
      end: 5,
      suffix: "+",
      title: "Years Experience",
    },
    {
      icon: "bi bi-globe2",
      end: 10,
      suffix: "+",
      title: "Countries Served",
    },
  ];
  // Advanced Scroll-Reveal Intersection Observer Engine
  useEffect(() => {
    const elements = document.querySelectorAll(
      ".reveal-element, .revealVault, .revealX",
    );

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("active");
          }
        });
      },
      {
        threshold: 0.15,
        rootMargin: "0px 0px -50px 0px",
      },
    );

    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);
  return (
    <>
      {/* HERO SECTION */}
      <section className="hero-section" id="home" data-aos="fade-down">
        <div className="hero-overlay">
          <div className="hero-content">
            <span className="hero-badge reveal-element" data-aos="fade-up">
              Next-Gen Digital Architecture
            </span>
            <h1
              className="reveal-element"
              data-aos="fade-up"
              data-aos-delay="150"
            >
              Welcome to{" "}
              <span className="text-gradient">LifeTime Infotech</span>
            </h1>
            <p
              className="reveal-element"
              data-aos="fade-up"
              data-aos-delay="300"
            >
              We build innovative solutions for web, mobile, and enterprise
              platforms engineered for performance and global scale.
            </p>

            <div
              className="hero-buttons reveal-element"
              data-aos="zoom-in"
              data-aos-delay="450"
            >
              <Link to="/services" className="btn btn-primary">
                Our Services <i className="bi bi-arrow-right-short"></i>
              </Link>
              <Link to="/contact1" className="btn btn-secondary">
                Contact Us
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* ABOUT US SECTION */}
      <section className="aboutVaultSection revealVault" data-aos="fade-up">
        <div className="aboutVaultContainer">
          {/* IMAGE SIDE */}
          <div className="aboutVaultMedia" data-aos="fade-right">
            <div className="aboutVaultImageBox">
              <img src="/images/hero.jpeg" alt="About Lifetime Infotech" />

              <div className="aboutVaultGlow"></div>
              <div className="aboutVaultRing"></div>
            </div>
          </div>

          {/* CONTENT SIDE */}
          <div className="aboutVaultContent" data-aos="fade-left">
            <span className="whyXTag">WHO WE ARE</span>

            <h2>
              We transform ideas into <span>digital reality</span>
            </h2>

            <p>
              LifeTime Infotech is a modern software development company
              delivering high-performance web apps, mobile applications, and
              enterprise-grade digital solutions.
            </p>

            <p>
              Our team blends design thinking, engineering excellence, and
              innovation to help businesses scale faster in the digital world.
            </p>

            <Link to="/about" className="aboutVaultBtn">
              Read More
              <i className="bi bi-arrow-right"></i>
            </Link>
          </div>
        </div>
      </section>

      {/* WHY CHOOSE US SECTION */}
      <section className="whyXSection revealX" data-aos="fade-up">
        <div className="whyXContainer">
          {/* LEFT CONTENT */}
          <div className="whyXContent" data-aos="fade-right">
            <span className="whyXTag">OUR ADVANTAGES</span>

            <h2>
              Why Choose{" "}
              <span className="text-gradient">LifeTime Infotech</span>
            </h2>

            {/* <div className="whyXGrid">
              <div className="whyXCard">
                <div className="whyXIcon">
                  <i className="bi bi-shield-check"></i>
                </div>
                <div>
                  <h3>Expert Development Team</h3>
                  <p>Skilled engineers with strong UI/UX design thinking.</p>
                </div>
              </div>

              <div className="whyXCard">
                <div className="whyXIcon">
                  <i className="bi bi-cpu"></i>
                </div>
                <div>
                  <h3>High Scalability</h3>
                  <p>Cloud-ready systems built for large-scale traffic.</p>
                </div>
              </div>

              <div className="whyXCard">
                <div className="whyXIcon">
                  <i className="bi bi-clock"></i>
                </div>
                <div>
                  <h3>On-Time Delivery</h3>
                  <p>Agile workflows ensuring fast and reliable delivery.</p>
                </div>
              </div>

              <div className="whyXCard">
                <div className="whyXIcon">
                  <i className="bi bi-headset"></i>
                </div>
                <div>
                  <h3>24/7 Support</h3>
                  <p>Always available technical assistance and monitoring.</p>
                </div>
              </div>
            </div> */}
            <div className="whyV2Item" data-aos="fade-up" data-aos-delay="100">
              <i className="bi bi-check-circle"></i>
              <p>Affordable pricing</p>
            </div>

            <div className="whyV2Item" data-aos="fade-up" data-aos-delay="200">
              <i className="bi bi-check-circle"></i>
              <p>High quality and scalable solutions</p>
            </div>

            {/* <div className="whyV2Item">
              <i className="bi bi-check-circle"></i>
              <p>Agile development methodology</p>
            </div> */}

            <div className="whyV2Item" data-aos="fade-up" data-aos-delay="300">
              <i className="bi bi-check-circle"></i>
              <p>On-time project delivery</p>
            </div>
            <div className="whyV2Item" data-aos="fade-up" data-aos-delay="400">
              <i className="bi bi-check-circle"></i>
              <p>24/7 customer support</p>
            </div>
          </div>

          {/* RIGHT IMAGE */}
          <div className="whyXImage" data-aos="fade-left">
            <div className="aboutVaultMedia">
              <div className="aboutVaultImageBox1">
                <img src="/images/landing-team.jpg" alt="Why choose us" />

                <div className="whyXGlow"></div>
                <div className="aboutVaultRing"></div>
              </div>
            </div>
            {/* <div className="whyXImageBox">
              <img src="/images/whychoose.jpg" alt="Why choose us" />
              <div className="whyXGlow"></div>
            </div> */}
          </div>
        </div>
      </section>
      {/* STATS SECTION */}
      <section className="stats-section" ref={ref} data-aos="fade-up">
        <div className="stats-container">
          <h2 className="stats-title">
            Our <span>Achievements</span>
          </h2>

          <div className="stats-grid">
            {stats.map((item, index) => (
              <div className="stat-card" key={index} data-aos="fade-up">
                <i className={item.icon}></i>

                <h3>
                  {inView && (
                    <CountUp
                      end={item.end}
                      duration={4.5}
                      suffix={item.suffix}
                    />
                  )}
                </h3>

                <p>{item.title}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* PREVIEWS GRID SECTION */}
      <section className="home-services reveal-element" data-aos="fade-up">
        <div className="services-container">
          <span className="whyXTag">ELEVATE YOUR BUSINESS</span>
          <h2 className="services-title">
            Custom IT Solutions Built to Perform
          </h2>

          <div className="services-grid">
            <Link
              to="/portfolio#mobile"
              className="service-card"
              data-aos="zoom-in"
              data-aos-delay="100"
            >
              <div className="card-hover-overlay"></div>
              <i className="bi bi-phone"></i>
              <h3>App Development</h3>
              <p>
                Build powerful native and cross-platform mobile ecosystems for
                iOS and Android.
              </p>
            </Link>

            <Link
              to="/portfolio#web"
              className="service-card"
              data-aos="zoom-in"
              data-aos-delay="200"
            >
              <div className="card-hover-overlay"></div>
              <i className="bi bi-globe"></i>
              <h3>Web Development</h3>
              <p>
                Create highly secure, fast-loading, and headless responsive web
                architectures.
              </p>
            </Link>

            <Link
              to="/portfolio#uiux"
              className="service-card"
              data-aos="zoom-in"
              data-aos-delay="300"
            >
              <div className="card-hover-overlay"></div>
              <i className="bi bi-palette"></i>
              <h3>UI/UX Design</h3>
              <p>
                User-centered research and stunning visual systems mapping
                customer retention metrics.
              </p>
            </Link>

            <Link
              to="/portfolio#marketing"
              className="service-card"
              data-aos="zoom-in"
              data-aos-delay="400"
            >
              <div className="card-hover-overlay"></div>
              <i className="bi bi-megaphone"></i>
              <h3>Digital Marketing</h3>
              <p>
                Grow digital conversions and organic reach through data-backed
                algorithmic SEO tactics.
              </p>
            </Link>
          </div>
        </div>
      </section>

      {/* INJECTED COMPONENT */}
      <Services showHeader={false} />

      {/* DETAILED SERVICES TECH FOCUS */}
      <section className="detailed-services reveal-element" data-aos="fade-up">
        <div className="detailed-container">
          <div
            className="detailed-card"
            data-aos="flip-left"
            data-aos-delay="100"
          >
            <div className="service-icon">
              <i className="bi bi-lightbulb"></i>
            </div>
            <h3>Mobile App Architecture</h3>
            <p>
              Developing mobile frameworks over the years, we've gained profound
              expertise in this domain. We target high-grade performance modules
              ensuring optimized rendering.
            </p>
            <div className="tech-icons">
              <i className="bi bi-apple"></i>
              <i className="bi bi-android2"></i>
              <i className="bi bi-phone"></i>
            </div>
          </div>

          <div
            className="detailed-card"
            data-aos="flip-left"
            data-aos-delay="200"
          >
            <div className="service-icon">
              <i className="bi bi-code-slash"></i>
            </div>
            <h3>Modern Web Engineering</h3>
            <p>
              People nowadays are mobile-first. So when you plan to build, we
              deploy production-optimized frontend interfaces backed by fast,
              microservice backend clusters.
            </p>
            <div className="tech-icons">
              <i className="bi bi-filetype-html"></i>
              <i className="bi bi-filetype-css"></i>
              <i className="bi bi-filetype-js"></i>
              <i className="bi bi-bootstrap"></i>
            </div>
          </div>
          <div
            className="detailed-card"
            data-aos="flip-right"
            data-aos-delay="300"
          >
            <div className="service-icon">
              <i className="bi bi-bezier2"></i>
            </div>
            <h3>Experience Engineering</h3>
            <p>
              We sketch intuitive paths across web and mobile platforms to
              dramatically drop abandonment rates and elevate conversion
              benchmarks.
            </p>
            <div className="tech-icons">
              <i className="bi bi-bezier"></i>
              <i className="bi bi-vector-pen"></i>
              <i className="bi bi-brush"></i>
            </div>
          </div>

          <div
            className="detailed-card"
            data-aos="flip-right"
            data-aos-delay="400"
          >
            <div className="service-icon">
              <i className="bi bi-graph-up-arrow"></i>
            </div>
            <h3>Growth Marketing</h3>
            <p>
              Scale visible footprints utilizing continuous A/B split
              performance campaigns alongside technical search visibility
              audits.
            </p>
            <div className="tech-icons">
              <i className="bi bi-search"></i>
              <i className="bi bi-graph-up"></i>
              <i className="bi bi-google"></i>
              <i className="bi bi-instagram"></i>
            </div>
          </div>
        </div>
      </section>

      {/* WORK METHODOLOGY */}
      <section className="work-methodology reveal-element" data-aos="fade-up">
        <div className="methodology-container">
          <h2 className="methodology-title" data-aos="fade-down">
            Our Work <span>Methodology</span>
          </h2>

          <div className="methodology-grid">
            <div
              className="method-card"
              data-aos="zoom-in-up"
              data-aos-delay="100"
            >
              <span className="step-num">01</span>
              <i className="bi bi-lightbulb"></i>
              <h3>Ideate</h3>
              <p>
                Translating initial business metrics into fully specified
                development definitions.
              </p>
            </div>

            <div
              className="method-card"
              data-aos="zoom-in-up"
              data-aos-delay="200"
            >
              <span className="step-num">02</span>
              <i className="bi bi-diagram-3"></i>
              <h3>Strategize</h3>
              <p>
                Constructing explicit user-journey paths and technical
                infrastructure blueprints.
              </p>
            </div>

            <div
              className="method-card"
              data-aos="zoom-in-up"
              data-aos-delay="300"
            >
              <span className="step-num">03</span>
              <i className="bi bi-tools"></i>
              <h3>Build</h3>
              <p>
                Agile engineering execution, multi-stage refactoring, and active
                unit validation.
              </p>
            </div>

            <div
              className="method-card"
              data-aos="zoom-in-up"
              data-aos-delay="400"
            >
              <span className="step-num">04</span>
              <i className="bi bi-rocket"></i>
              <h3>Launch</h3>
              <p>
                Exacting QA parameters completed, followed by production
                deployment launch environments.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Home;
